import DataQuery from "data/DataQuery";
import { Fueling_FuelingHistory } from "data/endpoints";
import { useQuery } from "data/hooks/useQuery";
import { formatISO } from "date-fns";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import MeasuredDataResultDTO from "features/shared/dtos/MeasuredDataResultDTO";
import { QuotationType } from "features/shared/enums/quotationType";
import React, { useEffect } from "react";
import MeasuredDataGraphCard from "features/shared/components/graphs/MeasuredDataGraphCard";
import { CommodityDetail } from "features/contracts/enums/commodityDetail";

type Props = {
  entityId: string;
  entityType: "Contract" | "Customer";
  commodityDetail: CommodityDetail;
  from: Date;
  to: Date;
  quotationType: QuotationType;
  noContentText?: string;
  noContentRender?: () => JSX.Element;
  setHasFuelingHistory?: React.Dispatch<React.SetStateAction<boolean>>;
};

const FuelingGraphSection = ({
  entityId,
  entityType,
  commodityDetail,
  from,
  to,
  quotationType,
  noContentText,
  noContentRender,
  setHasFuelingHistory
}: Props) => {
  // helpers
  const getFuelingHistoryParams = () => {
    let params = new URLSearchParams({
      From: formatISO(from, { representation: "date" }),
      To: formatISO(to, { representation: "date" }),
      QuotationType: quotationType,
    });

    params.set(`${entityType}Id`, entityId);

    return params;
  };

  // fetch data
  const fuelingHistoryQuery: DataQuery = {
    url: Fueling_FuelingHistory,
    params: getFuelingHistoryParams(),
  };
  const { data: fuelingHistory, loadStatus } = useQuery<MeasuredDataResultDTO>(
    fuelingHistoryQuery,
    { measuredValues: [] },
    [ getFuelingHistoryParams().toString() ]
  );

  // side-effects
  useEffect(() => {
    if (
      setHasFuelingHistory &&
      loadStatus == "AfterFirstLoad" &&
      !isEmptyFuelingHistory()
    ) {
      setHasFuelingHistory(true);
    }
  }, [getFuelingHistoryParams().toString(), loadStatus]);
  
  // helpers
  const isEmptyFuelingHistory = (): boolean => { 
    if (fuelingHistory.measuredValues && fuelingHistory.measuredValues.length == 0) {
      return true;
    }

    return false;
  }

  // render
  return (
    <NoContentWrapper
      data={fuelingHistory}
      loadStatus={loadStatus}
      noContentInfo={noContentText}
      noContentAsAlert
      noContentRender={noContentRender}
      isEmpty={isEmptyFuelingHistory}
    >
      <MeasuredDataGraphCard
        commodityDetail={commodityDetail}
        realValues={fuelingHistory}
        showLegend
      />
    </NoContentWrapper>
  );
};

export default FuelingGraphSection;
